import i18n from '@/i18n'
import Index from './index.vue'
import Layout from '../../companyAdmin/layout.vue'

const basePath = '/v-admin/client-management/export-data'

export default {
  path: `${basePath}`,
  component: Layout,
  meta: {
    isNewPage: true,
    isAllInclude: true,
    permission: 'PERM_ADMIN_EXPORT_DATA',
    titleI18nKey: 'admin.customer.exportDataManagement.title',
    menu: {
      get label () {
        return i18n.t('admin.customer.exportDataManagement.menu')
      }
    }
  },
  children: [
    {
      path: `${basePath}`,
      component: Index,
      meta: {
        breadcrumb: { hidden: true },
        permission: 'PERM_ADMIN_EXPORT_DATA',
        titleI18nKey: 'admin.customer.exportDataManagement.title'
      }
    }
  ]
}
